import { useState, useCallback, lazy, Suspense } from "react";
import TowerLoading from "@/components/landing/TowerLoading";
import ElevatorEntry from "@/components/landing/ElevatorEntry";
import FloorPath from "@/components/landing/FloorPath";
import FloorIndicator from "@/components/landing/FloorIndicator";
import { CheckoutProvider } from "@/contexts/CheckoutContext";

const FullScreenCheckout = lazy(() => import("@/components/checkout/FullScreenCheckout"));

// Lazy load everything below the fold
const FloorShame = lazy(() => import("@/components/landing/FloorShame"));
const FloorDream = lazy(() => import("@/components/landing/FloorDream"));
const FloorKey = lazy(() => import("@/components/landing/FloorKey"));
const FloorWhy = lazy(() => import("@/components/landing/FloorWhy"));
const FloorSystem = lazy(() => import("@/components/landing/FloorSystem"));
const FloorReceipts = lazy(() => import("@/components/landing/FloorReceipts"));
const FloorDecision = lazy(() => import("@/components/landing/FloorDecision"));
const FloorBinary = lazy(() => import("@/components/landing/FloorBinary"));
const OnyxChat = lazy(() => import("@/components/landing/OnyxChat"));
const FloorLockIn = lazy(() => import("@/components/landing/FloorLockIn"));
const LeadMagnet = lazy(() => import("@/components/landing/LeadMagnet"));
const LeadMagnetPopup = lazy(() => import("@/components/landing/LeadMagnetPopup"));
const OnyxChip = lazy(() => import("@/components/landing/OnyxChip"));
const Footer = lazy(() => import("@/components/landing/Footer"));

const Index = () => {
  const [loaded, setLoaded] = useState(false);

  const handleLoadComplete = useCallback(() => {
    setLoaded(true);
  }, []);

  return (
    <CheckoutProvider>
      <div className="noise-overlay">
        <TowerLoading onComplete={handleLoadComplete} />
        <FloorIndicator />
        <ElevatorEntry loaded={loaded} />
        <FloorPath />
        <Suspense fallback={null}>
          <FloorShame />
          <FloorDream />
          <FloorKey />
          <FloorWhy />
          <FloorSystem />
          <FloorReceipts />
          <FloorDecision />
          <FloorBinary />
          {/* Onyx now sits AFTER the full pitch — it's a final-objection handler */}
          <OnyxChat />
          <FloorLockIn />
          {/* Free kit as final section before footer */}
          <LeadMagnet />
          <FullScreenCheckout />
          <Footer />
          <OnyxChip />
          <LeadMagnetPopup />
        </Suspense>
      </div>
    </CheckoutProvider>
  );
};

export default Index;
